import {
  mdiHandshake,
  mdiPackageVariant,
  mdiClipboardListOutline,
  mdiHistory,
  mdiClipboardArrowUpOutline,
  mdiStarBoxMultipleOutline,
  mdiWarehouse,
  mdiCar,
  mdiPackageVariantClosed,
  mdiClipboardArrowLeftOutline,
  mdiAccountMultipleOutline,
  mdiCounter,
  mdiMapMarkerRadiusOutline,
  mdiArchiveOutline,
  mdiAccountSupervisor,
  mdiWeb,
  mdiExitToApp,
  mdiBellOutline,
  mdiWallet,
  mdiCardAccountPhone,
  mdiCogBox,
  mdiChatQuestion,
} from '@mdi/js';
import {
  dsiOrderManagement,
  dsiParcel,
  dsiWarehouseManagement,
  dsiPackaging,
  dsiFinance,
  dsiSupport,
  dsiSetting,
} from '../../components/icons/customIcons';
import {Menus} from './interfaces';

const menus: Menus = [
  // {
  //   id: 234,
  //   path: '/vitrin-orders',
  //   sideMenuName: 'ویترین',
  //   icon: '/vitrin.svg',
  //   subMenu: [
  //     {
  //       id: 237,
  //       path: '/vitrin/categories',
  //       sideMenuName: 'ویترین شاپ',
  //       icon: mdiCounter,
  //     },
  //     {
  //       id: 235,
  //       path: '/incoming-orders',
  //       sideMenuName: 'سفارش های دریافتی',
  //       icon: mdiWarehouse,
  //     },
  //     {
  //       id: 236,
  //       path: '/vitrin-orders',
  //       sideMenuName: 'سفارش های ویترین',
  //       icon: mdiPackageVariantClosed,
  //     },
  //     {
  //       id: 237,
  //       path: '/vitrin-your-products',
  //       sideMenuName: 'کالاهای منتخب',
  //       icon: mdiPackageVariantClosed,
  //     },
  //   ],
  // },

  {
    id: 123,
    path: '/orders',
    sideMenuName: 'سفارش‌ها',
    icon: dsiOrderManagement,
  },
  // {
  //   id: 300,
  //   path: '/orders-menu',
  //   sideMenuName: 'مدیریت سفارش‌ها',
  //   icon: dsiOrderManagement,
  //   subMenu: [

  //     {
  //       id: 301,
  //       path: '/digikala-link-PLACEHOLDER',
  //       icon: mdiPackageVariant,
  //       sideMenuName: 'دیجی‌کالا',
  //     },
  //   ],
  // },
  {
    id: 37,
    path: '/seller-orders',
    icon: mdiPackageVariant,
    sideMenuName: 'سفارش‌ها',
  },
  {
    id: 400,
    path: '/parcels-menu',
    sideMenuName: 'محموله',
    icon: dsiParcel,
    subMenu: [
      {
        id: 38,
        path: '/seller-parcels',
        icon: mdiClipboardArrowUpOutline,
        sideMenuName: 'ارسال محموله',
      },
      {
        id: 21,
        path: '/parcels-sender',
        sideMenuName: 'ارسال محموله',
        icon: mdiClipboardArrowUpOutline,
      },
      {
        id: 25,
        path: '/warehouse-admin-parcels-receipts',
        sideMenuName: ' محموله‌های دریافتی',
        icon: mdiPackageVariantClosed,
      },
    ],
  },

  {
    id: 6,
    path: '/partners',
    sideMenuName: 'مدیریت شرکت‌ها',
    icon: mdiHandshake,
  },
  /*{
    id: 41,
    path: '/partner-account',
    sideMenuName: 'مدیریت اکانت',
    icon: mdiAccountTie,
  },*/
  {
    id: 36,
    path: '/vip-orders',
    icon: mdiStarBoxMultipleOutline,
    sideMenuName: 'سفارش‌های ارسال ویژه',
  },
  {
    id: 34,
    path: '/nonPost-orders',
    icon: mdiPackageVariant,
    sideMenuName: 'سفارش‌های لجستیک',
  },
  {
    id: 29,
    path: '/post-orders',
    icon: mdiPackageVariant,
    sideMenuName: 'مرسوله‌های پست',
  },
  {
    id: 33,
    path: '/pickups',
    sideMenuName: 'لیست جمع آوری محموله',
    icon: mdiWarehouse,
  },
  {
    id: 31,
    path: '/fleets',
    icon: mdiCar,
    sideMenuName: 'مدیریت ناوگان‌ها',
  },
  {
    id: 14,
    path: '/warehouse-admin-orders',
    icon: mdiPackageVariant,
    sideMenuName: 'سفارش‌ها',
  },
  // {
  //   id: 15,
  //   path: '/delivery-orders',
  //   icon: mdiTruckDeliveryOutline,
  //   sideMenuName: 'تحویل سفارش‌ها',
  // },
  {
    id: 12,
    path: '/bundles-deliver',
    icon: mdiPackageVariantClosed,
    sideMenuName: 'تحویل مرسوله‌ها',
  },
  {
    id: 73,
    path: '/bundles',
    icon: mdiPackageVariantClosed,
    sideMenuName: 'مدیریت مرسوله‌ها',
  },
  {
    id: 13,
    path: '/assignment',
    icon: mdiClipboardArrowLeftOutline,
    sideMenuName: 'تخصیص بسته به راننده',
  },
  {
    id: 35,
    path: '/drivers-wallet',
    sideMenuName: 'کیف پول رانندگان',
    icon: mdiCar,
  },
  {
    id: 5,
    path: '/users',
    sideMenuName: 'مدیریت کاربر‌ها',
    icon: mdiAccountMultipleOutline,
  },
  {
    id: 25,
    path: '/warehouse-zones',
    sideMenuName: 'مدیریت بخش‌های انبار',
    icon: mdiWarehouse,
  },

  // {
  //   id: 2,
  //   path: '/upload-info',
  //   sideMenuName: 'بارگذاری اطلاعات',
  //   icon: mdiFileUploadOutline,
  // },
  {
    id: 7,
    path: '/warehouses-menu',
    sideMenuName: 'مدیریت انبارها',
    icon: dsiWarehouseManagement,
    subMenu: [
      {
        id: 7,
        path: '/warehouses',
        sideMenuName: 'لیست انبارها',
        icon: mdiWarehouse,
      },
      {
        id: 15,
        path: '/parcels',
        sideMenuName: 'محموله',
        icon: mdiPackageVariantClosed,
      },
      {
        id: 14,
        path: '/warehouses/inventory',
        sideMenuName: 'موجودی',
        icon: mdiCounter,
      },
      {
        id: 19,
        path: '/centersStatistics',
        sideMenuName: 'آمار سفارش‌ها',
        icon: mdiPackageVariant,
      },
    ],
  },
  {
    id: 39,
    path: '/warehouse/inventory',
    icon: mdiWarehouse,
    sideMenuName: 'موجودی انبار',
    subMenu: [
      {
        id: 40,
        path: '/warehouses/your-inventory',
        sideMenuName: 'لیست موجودی انبار',
        icon: mdiClipboardListOutline,
      },
      {
        id: 41,
        path: '/warehouses/product-history',
        sideMenuName: 'تاریخچه کالا',
        icon: mdiHistory,
      },
    ],
  },
  {
    id: 22,
    path: '/your-products',
    sideMenuName: 'مدیریت انبار',
    icon: dsiWarehouseManagement,
    subMenu: [
      {
        id: 18,
        path: '/partner-warehouses/inventory',
        sideMenuName: 'موجودی انبار',
        icon: mdiCounter,
      },
      {
        id: 22,
        path: '/your-products',
        sideMenuName: 'کالاها',
        icon: mdiArchiveOutline,
      },
      {
        id: 30,
        path: '/providers',
        sideMenuName: 'تامین‌کنندگان',
        icon: mdiAccountSupervisor,
      },
      {
        id: 31,
        path: '/sellers',
        sideMenuName: 'فروشندگان',
        icon: mdiAccountSupervisor,
      },
    ],
  },
  {
    id: 401,
    path: '/packaging',
    sideMenuName: 'بسته‌بندی',
    icon: dsiPackaging,
    subMenu: [
      {
        id: 411,
        path: '/packaging-consumption-report',
        sideMenuName: 'گزارش مصرف',
        icon: dsiPackaging,
      },
      {
        id: 421,
        path: '/packaging-preferences',
        sideMenuName: 'تنظیمات',
        icon: dsiPackaging,
      },
    ],
  },
  {
    id: 118,
    path: '/financial-management',
    sideMenuName: 'مالی',
    icon: dsiFinance,
  },
  {
    id: 500,
    path: '/alltickets',
    sideMenuName: 'پشتیبانی',
    icon: dsiSupport,
    // icon: mdiChatQuestion,
    disabled: process.env.REACT_APP_ENVIROMENT == "sandbox"
  },
  {
    id: 600,
    path: '/setting',
    sideMenuName: 'تنظیمات',
    icon: dsiSetting,
    subMenu: [
      {
        id: 23,
        path: '/your-centers',
        sideMenuName: 'مدیریت مراکز',
        icon: mdiMapMarkerRadiusOutline,
      },
      {
        id: 24,
        path: '/integration',
        sideMenuName: 'یکپارچگی',
        icon: mdiMapMarkerRadiusOutline,
      },
      {
        id: 117,
        path: '/notification',
        sideMenuName: 'اعلان ها',
        icon: mdiBellOutline,
      },

      {
        id: 38,
        path: '/webhooks',
        icon: mdiWeb,
        sideMenuName: 'وب‌هوک',
      },
    ],
  },
  {
    id: 42,
    path: '/seller-products',
    sideMenuName: 'مدیریت کالاها',
    icon: mdiArchiveOutline,
  },
  {
    id: 24,
    path: '/parcels-receipt',
    sideMenuName: ' محموله‌های دریافتی',
    icon: mdiPackageVariantClosed,
  },
  {
    id: 32,
    path: '/warehouse-operator-orders',
    sideMenuName: 'سفارش‌های تخصیص داده شده',
    icon: mdiPackageVariant,
  },
  {
    id: 29,
    path: '/parcels-warehouse-operator',
    sideMenuName: 'محموله',
    icon: mdiPackageVariantClosed,
  },
  // {
  //   id: 50,
  //   path: '/canceled-orders',
  //   sideMenuName: 'سفارش های کنسل شده',
  //   icon: mdiGiftOffOutline,
  // },
  // {
  //   id: 8,
  //   path: '/reports/current-orders',
  //   icon: mdiFileUploadOutline,
  //   sideMenuName: 'گزارشها',
  //   subMenu: [
  //     {
  //       id: 81,
  //       path: '/reports/current-orders',
  //       icon: mdiFileUploadOutline,
  //       sideMenuName: 'سفارش‌های جاری',
  //     },
  //   ],
  // },
  {
    id: 46,
    path: '/organize-bundles',
    icon: mdiPackageVariantClosed,
    sideMenuName: 'سید بندی سفارش',
  },
  {
    id: 32,
    path: '/relocate',
    sideMenuName: 'جابه‌جایی',
    icon: mdiWarehouse,
    subMenu: [
      {
        id: 7,
        path: '/relocate/by-item',
        sideMenuName: 'جابه‌جایی آیتم انبار',
        icon: mdiWarehouse,
      },
    ],
  },
  // {
  //   id: 3,
  //   path: '/login',
  //   sideMenuName: 'خروج',
  //   icon: mdiExitToApp,
  //   onClick: 'logout',
  //   dataCy: 'logout',
  // },
];

export default menus;
